// extracted by mini-css-extract-plugin
module.exports = {"container":"JO","overlay":"KO","headingSection":"LO","close":"MO","copy":"NO","m-heart-activate":"OO","bottomSection":"PO","disabled":"QO","m-heart-pulse":"RO"};